"use client"

import { Skeleton } from "@/components/ui/skeleton"

export function BlogArticleSkeleton() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero image skeleton */}
      <div className="relative h-64 sm:h-80 md:h-96 bg-gray-100">
        <Skeleton className="absolute inset-0" />
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Breadcrumb skeleton */}
        <div className="flex gap-2 mb-6">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-24" />
        </div>

        {/* Category badge */}
        <Skeleton className="h-6 w-24 rounded-full mb-4" />

        {/* Title skeleton */}
        <Skeleton className="h-10 w-full mb-2" />
        <Skeleton className="h-10 w-3/4 mb-6" />

        {/* Meta info skeleton */}
        <div className="flex flex-wrap gap-4 mb-8 pb-6 border-b">
          <div className="flex items-center gap-2">
            <Skeleton className="h-10 w-10 rounded-full" />
            <div>
              <Skeleton className="h-4 w-24 mb-1" />
              <Skeleton className="h-3 w-32" />
            </div>
          </div>
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-20" />
        </div>

        {/* Content skeleton */}
        <div className="space-y-4">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />

          <div className="py-4" />

          <Skeleton className="h-6 w-48 mb-2" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />

          <div className="py-4" />

          <Skeleton className="h-48 w-full rounded-lg" />

          <div className="py-4" />

          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
    </div>
  )
}
